import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface ITargetTemplate {
    /// unique ID for this record
    ID: number;

    /// the name of the template.
    TemplateName: string;

    /// the ID of the template type.
    TargetTemplateTypeID: number;

    /// if this template is active or not.
    IsActive: boolean;

    // custom fields
    FormItems: ITargetTemplateFormItem[];

    // address fields
    AddressFormItems: ITargetTemplateFormItem[];
}

export interface ITargetTemplateFormItem {
    /// unique ID for this field.
    ID: number;

    /// the label to appear next to the control
    FormText: string;

    /// if true, then a value must be entered into the field
    IsRequired: boolean;
    ControlTypeID: number;
    IsActive: boolean;
    ShowInGrid: boolean;
    ShowInMobileAppointmentHeader: boolean;
    CanChangeControlType: boolean;
    ListValues: IListValue[];
    TemplatePhraseID: number;
}

export interface IListValue {
    ID: number;
    Value: string;
    IsActive: boolean;
}

export interface ITargetTemplateType {
    /// unique ID for the type
    ID: number;

    /// the name of the type
    Name: string;

    /// if true, then the user is allowed to enter custom fields
    HasCustomFields: boolean;

    // if true, then the user is allowed to enter address fields
    HasAddressFields: boolean;
}

export interface ITargetTemplateControlType {
    ID: number;
    Name: string;
    IsBinaryData: boolean;
    HasListValues: boolean;
}

export interface ITargetTemplateMaster {
    TargetTemplate: ITargetTemplate;
    /// a list of all possible target template types.
    TargetTemplateTypes: ITargetTemplateType[];
    // List of all controls that can be used by targets
    ControlTypes: ITargetTemplateControlType[];
    TemplatePhrases: ITemplatePhrases[];
}

export interface ITemplatePhrases {
    ID: number;
    CustomerID: number;
    PhraseName: string;
    IsActive: boolean;
    Details: ITemplatePhraseDetails[];
}
export interface ITemplatePhraseDetails {
    ID: number;
    Phrase: string;
    SortOrder: number;
    IsActive: boolean;
}

export function GetMaster(id: number): JQueryDeferred<Data.IResponse<ITargetTemplateMaster>> {
    return Util.callWebService(
        "/api/TargetTemplate/" + id,
        "GET");
}

export function Save(targetTemplate: ITargetTemplate): JQueryDeferred<Data.IResponse<ITargetTemplate>> {
    return Util.callWebService(
        "/api/TargetTemplate/Save",
        "POST",
        targetTemplate);
}

/// used to change the IsActive status of a TargetTemplate object
export interface ITargetTemplateSetIsActiveRequest {
    /// the ID of the TargetTemplate to change.
    TargetTemplateID: number;

    /// the new value for the IsActive status.
    IsActive: boolean;
}

export function SetIsActive(request: ITargetTemplateSetIsActiveRequest): JQueryDeferred<Data.IResponse<ITargetTemplate>> {
    return Util.callWebService(
        "/api/TargetTemplate/SetIsActive",
        "POST",
        request);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/targetTemplateData.ts